import React from 'react';
import { TextFieldForm } from 'web-library';
import { useTranslation } from 'react-i18next';

import ToggleDisplayEditFormItem from '../../../../../components/ToggleDisplayEditFormItem';
import { AdminProfilePersonalParticularsProps } from '../AdminProfilePersonalParticulars';
import { useStyles } from '../styles';

const AdminNameRelatedComponent = ({
  isEditState,
  formHook,
  isDisableInputs = undefined,
  isHideExtraFormInfo = false,
  formDefaultValues = undefined,
  isProfileUploading = false,
}: AdminProfilePersonalParticularsProps) => {
  const { control, formState: { errors } } = formHook;
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('admin->>CreateOpsAdminForm.Name')} // TODO
        valueText={formDefaultValues?.statutoryName}
        id="statutoryName"
        containerClassName={classes.formElementContainer}
        EditComponent={
          <>
            <TextFieldForm
              form={formHook}
              isInputTextUpperCase
              onChange={(e) => formHook?.setValue('statutoryName', e.target.value.toUpperCase())}
              label={t('admin->>CreateOpsAdminForm.Name')}
              name="statutoryName"
              type="text"
              defaultValue={formDefaultValues?.statutoryName}
              error={!!errors.statutoryName}
              helperText={errors?.statutoryName?.message?.toString()}
              fullWidth
              inputProps={{ disabled: isDisableInputs?.statutoryName || isProfileUploading }}
            />
          </>
        }
      />
    </>
  );
};

export default AdminNameRelatedComponent;
